

<div class="mms-worksheet p-20 m-0-auto">

    <!-- Header -->
    <div class="mms-ws-header">
      <div class="flex flex-horiz-space-bw">
        <div>
          <img src="/assets/images/logos/mmslogo.png" alt="LOGO" class="mms-ws-header-logo"/>
        </div>
        <div class="mms-ws-header-addr">
            <h5>MetaMorphoSys Insurance Corp.</h5>
            <p>Himgiri Bungalow, LA-Ratan Lane</p>
            <p>Baner, MH 411045</p>
        </div>
      </div>
    </div>
  
    <!-- Claim Details -->
    <div>
      <div class="title-emphasis">
        <i nz-icon class="title-ico" nzType="audit"></i>
        <div>
          <h4 class="p-0 m-0">Claim Assessment Worksheet</h4>
          <span class="col-grey-dark">#CLM0000107</span>
        </div>
      </div>
  
      <!-- Summary -->
      <div class="summary-container summary-container-wide">
        <div>
          <span class="s-c-head">Policy No</span> PLF-00001-0001
        </div>
        <div>
          <span class="s-c-head">Product</span> StandardLife
        </div>
        <div>
          <span class="s-c-head">Plan</span> Individual
        </div>
        <div>
          <span class="s-c-head">Package</span> SILVER
        </div>
        <div>
          <span class="s-c-head">Premium Status</span> <nz-tag [nzColor]="'#87d068'">PAID</nz-tag>
        </div>
        <div>
          <span class="s-c-head">Commencement Date</span> 13 Sep 2012 <small class="d-b">(~7 years ago)</small>
        </div>
        <div>
          <span class="s-c-head">Policy Expiry Date</span> <nz-badge nzStatus="success">12 Sep 2020 </nz-badge> <small class="d-b">(in 11 months)</small>
        </div>
        <div>
          <span class="s-c-head">Policy Owner</span> Chris Hemsworth
        </div>
        <div>
          <span class="s-c-head">Life Insured Name</span> Chris Hemsworth
        </div>
        <div>
          <span class="s-c-head">Total Sum Insured</span> Rs 1 Cr.
        </div>
        <div>
          <span class="s-c-head">Premium</span> Rs 2350
        </div>
      </div>
  
  
      <div class="title-emphasis m-t-40">
        <i nz-icon class="title-ico" nzType="thunderbolt"></i>
        <div>
          <h4 class="p-0 m-0">Event Details</h4>
          <span class="col-grey-dark">#CLM0000107</span>
        </div>
      </div>
      <!-- Summary -->
      <div class="summary-container summary-container-wide">
        <div>
          <span class="s-c-head">Event</span> Death
        </div>
        <div>
          <span class="s-c-head">Cause of Event</span> Accident
        </div>
        <div>
          <span class="s-c-head">Event Date</span> 16 Sep 2019
        </div>
        <div>
          <span class="s-c-head">Event Intimation Date</span> <nz-badge nzStatus="success">20 Sep 2019 </nz-badge> <small class="d-b">(4 days after the event)</small>
        </div>
        <div>
          <span class="s-c-head">Age at event</span> 51 years
        </div>
      </div>
  
  
      <div class="d-b m-t-40"></div>
      <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false" nzSize="small">
        <thead class="table-header">
        <tr>
          <th>Fund Name</th>
          <th>No of units</th>
          <th>NAV date</th>
          <th>NAV value</th>
          <th>Fund Value</th>
        </tr>
        </thead>
        <tbody>
          <tr class="table-row">
            <td>Hedges Mutual</td>
            <td>10,000</td>
            <td>20 Sep 2012</td>
            <td>10,000</td>
            <td>INR 10 Cr</td>
          </tr>
        </tbody>
      </nz-table>
      <div class="d-b m-t-40"></div>
      <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false" nzSize="small">
        <thead class="table-header">
        <tr>
          <th>Sales Channel</th>
          <th>FA/FLS Name</th>
          <th>FA/FLS status</th>
          <th>No of Claims</th>
        </tr>
        </thead>
        <tbody>
          <tr class="table-row">
            <td>Agent</td>
            <td>Muthoot Banking and Finance Corporation</td>
            <td>Active</td>
            <td>5,680</td>
          </tr>
        </tbody>
      </nz-table>
  
      <!-- Wordings -->
      <div class="d-b m-t-40"></div>
      <div>
        <h4 class="p-t-b-10">Policy Details</h4>
        <div class="wordings">
          Life Insured was a
          <span class="pre">51 year old, Married, Male, Engineer,</span> with an annual income of
          <span class="pre">Rs 50 lakhs</span> has applied for
          <span class="pre">StandardLife</span> with
          <span class="pre">Rs 1 Cr.</span> for term of
          <span class="pre">10 years</span>.
          Policy was issued after
          <span class="pre">Investigation</span> on <span class="pre">13 Sep 2012</span>
          Benefit payable as per policy terms and condition is
          <span class="pre">Rs 1 Cr.</span>
        </div>
      </div>
  
      <div class="title-emphasis m-t-40">
        <i nz-icon class="title-ico" nzType="usergroup-add"></i>
        <div>
          <h4 class="p-0 m-0">Life Insured, Nomiees & Claimant</h4>
          <span class="col-grey-dark">#CLM0000107</span>
        </div>
      </div>
      <h3 class="d-b m-t-20 heading">Life Insured</h3>
      <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false" nzSize="small">
        <thead class="table-header">
        <tr>
          <th>Name</th>
          <th>DOB</th>
          <th>Contact</th>
          <th>Address</th>
        </tr>
        </thead>
        <tbody>
        <tr class="table-row">
          <td>Chris Hemsworth</td>
          <td>11 Jan 1976</td>
          <td>
            +91 9888766542 (Home) <br>
            +91 9888707070 (Work)
          </td>
          <td>Pine Woods, </td>
        </tr>
        </tbody>
      </nz-table>
  
      <h3 class="d-b m-t-20 heading">Nominees</h3>
      <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false" nzSize="small">
        <thead class="table-header">
        <tr>
          <th>Name</th>
          <th>DOB</th>
          <th>Contact</th>
          <th>Address</th>
        </tr>
        </thead>
        <tbody>
        <tr class="table-row">
          <td>Liam Hemsworth</td>
          <td>24 Feb 1987</td>
          <td>
            +91 9888766542 (Home) <br>
            +91 9888707070 (Work)
          </td>
          <td>
            <span class="s-c-head">Home</span>
            B3, Pine Woods, Realold Estate, PN 56006
            <span class="s-c-head m-t-10">Office</span>
            Ullaoor Towers, Ryzen 3600x, PN 56006
          </td>
        </tr>
        <tr class="table-row">
          <td>Liza Hemsworth</td>
          <td>21 Aug 1989</td>
          <td>
            +91 9899110019 (Home) <br>
            +91 7880099811 (Work)
          </td>
          <td>B3, Pine Woods, Realold Estate, PN 56006</td>
        </tr>
        </tbody>
      </nz-table>
  
      <h3 class="d-b m-t-20 heading">Claimant</h3>
      <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false" nzSize="small">
        <thead class="table-header">
        <tr>
          <th>Name</th>
          <th>DOB</th>
          <th>Contact</th>
          <th>Address</th>
        </tr>
        </thead>
        <tbody>
        <tr class="table-row">
          <td>Liam Hemsworth</td>
          <td>24 Feb 1987</td>
          <td>
            +91 9888766542 (Home) <br>
            +91 9888707070 (Work)
          </td>
          <td>B3, Pine Woods, Realold Estate, PN 56006</td>
        </tr>
        </tbody>
      </nz-table>
  
  
  
      <!-- TIMELINES -->
      <div class="title-emphasis m-t-40">
        <i nz-icon class="title-ico" nzType="project"></i>
        <div>
          <h4 class="p-0 m-0">Timeline of activities</h4>
          <span class="col-grey-dark">#CLM0000107</span>
        </div>
      </div>
      <div class="grid grid-gap-20 grid-3x p-t-0 m-t-0">
  
        <div>
          <h4 class="p-t-b-20 d-b">Activity Timeline</h4>
          <nz-timeline>
          <nz-timeline-item nzColor="green">
            <h4 class="f-w-600">Claim Investigation <nz-tag [nzColor]="'green'">Completed</nz-tag></h4>
            <p><i nz-icon nzType="calendar"></i> 5 Apr 2019 11:11 AM (5 days ago)</p>
            <p>
              Work queue: Investigation Level 1 <br>
              Assignee: aditya@metamorphtech.com
            </p>
          </nz-timeline-item>
          <nz-timeline-item nzColor="green">
            <h4 class="f-w-600">Claim Adjudication <nz-tag [nzColor]="'green'">Completed</nz-tag></h4>
            <p><i nz-icon nzType="calendar"></i> 5 Apr 2019 11:11 AM (5 days ago)</p>
            <p>
              Work queue: Adjudication Level 1 <br>
              Assignee: kewal@metamorphtech.com
            </p>
          </nz-timeline-item>
          <nz-timeline-item nzColor="green">
            <h4 class="f-w-600">Claim Registration <nz-tag [nzColor]="'green'">Completed</nz-tag></h4>
            <p><i nz-icon nzType="calendar"></i> 4 Apr 2019 11:10 AM (6 days ago)</p>
            <p>
              Work queue: Registration <br>
              Assignee: ganesh@metamorphtech.com <br>
              Priority: High <br>
              Completed in: 1 hour
            </p>
          </nz-timeline-item>
  
        </nz-timeline>
  
        </div>
  
        <div>
          <h4 class="p-t-b-20 d-b">Correspondence Timeline</h4>
          <nz-timeline>
            <nz-timeline-item nzColor="green">
              <h4 class="f-w-600">eMail <nz-tag [nzColor]="'green'">Sent</nz-tag></h4>
              <p><i nz-icon nzType="calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
              <p>
                To: riya@gmail.com <br>
                Message: Your claim is being processed <br>
                Attachment: <a>CLM0000107.EML</a>
              </p>
            </nz-timeline-item>
            <nz-timeline-item nzColor="green">
              <h4 class="f-w-600">SMS <nz-tag [nzColor]="'green'">Sent</nz-tag></h4>
              <p><i nz-icon nzType="calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
              <p>
                To: 9809862272 <br>
                Message: Your claim is being processed
              </p>
            </nz-timeline-item>
          </nz-timeline>
        </div>
  
      </div>
  
  
      <!-- Investigation -->
      <div class="title-emphasis m-t-40">
        <i nz-icon class="title-ico" nzType="security-scan"></i>
        <div>
          <h4 class="p-0 m-0">Investigation Details</h4>
          <span class="col-grey-dark">#CLM0000107</span>
        </div>
      </div>
  
      <div class="wordings">
        Investigation report received on
        <span class="pre">24 Sep 2019</span>. Investigation Summary:
      </div>
  
      <div class="d-b m-t-10"></div>
      <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false" nzSize="small">
        <thead class="table-header">
        <tr>
          <th></th>
          <th>Done by</th>
          <th>Start</th>
          <th>End</th>
          <th>Status</th>
          <th>Comment</th>
        </tr>
        </thead>
        <tbody>
            <!-- UW -->
            <tr class="table-row">
              <td><b>Underwriting Opinion</b></td>
              <td>Shilpa Singh</td>
              <td>13 Sep 2012</td>
              <td>13 Sep 2012</td>
              <td class="col-green">Passed</td>
              <td>Manual Underwriting</td>
            </tr>
            <!-- MEDICAL -->
            <tr class="table-row">
              <td><b>Medical Opinion</b></td>
              <td>Dr Rahul Jain</td>
              <td>23 Sep 2019</td>
              <td>23 Sep 2019</td>
              <td class="col-green">Approved</td>
              <td>Everything checks out</td>
            </tr>
            <tr class="table-row">
              <td><!--Leave blank --></td>
              <td>Dr Roy Mathew</td>
              <td>23 Sep 2019</td>
              <td>23 Sep 2019</td>
              <td class="col-green">Approved</td>
              <td></td>
            </tr>
  
            <!-- LEGAL -->
            <tr class="table-row">
              <td><b>Legal Opinion</b></td>
              <td>Adv. Sunil Mishra</td>
              <td>24 Sep 2019</td>
              <td>24 Sep 2019</td>
              <td class="col-green">Approved</td>
              <td>Everything checks out</td>
            </tr>
            <tr class="table-row">
              <td><!--Leave blank --></td>
              <td>Adv. Abhishek Kulkarni</td>
              <td>24 Sep 2019</td>
              <td>24 Sep 2019</td>
              <td class="col-green">Approved</td>
              <td>All OK</td>
            </tr>
  
            <!-- INVESTIGATION -->
            <tr class="table-row">
              <td><b>Investigator Opinion</b></td>
              <td>Basit Parkar (INT1)</td>
              <td>24 Sep 2019</td>
              <td>24 Sep 2019</td>
              <td class="col-green">Approved</td>
              <td>Everything checks out</td>
            </tr>
            <tr class="table-row">
              <td><!--Leave blank --></td>
              <td>Sharang Tarang (INT2)</td>
              <td>24 Sep 2019</td>
              <td>24 Sep 2019</td>
              <td class="col-green">Approved</td>
              <td>Everything checks out</td>
            </tr>
  
        </tbody>
      </nz-table>
  
  
  
    </div>
  
  
  
  </div>
  